import {observer_mgl, RunInAction} from "mobx-graphlink";
import {MapState} from "../../../../Store/main/maps/@MapState.js";
import {Button, Column, Row} from "react-vcomponents";
import React from "react";
import {E, WaitXThenRun} from "js-vextensions";
import {store} from "../../../../Store/index.js";
import {MapTool} from "./Tools/@Tool.js";
import {DMap} from "../../../../Server/DB/maps/@Map.js";
import {GetEntity} from "../../../../Server/DB/entities.js";
import {Vec2} from "../../../../Utils/ThreeJS/VectorStructs.js";
import {MapSurface_Current} from "../MapSurface.js";
import {ES, useForceUpdate} from "web-vcore";
import {SizeReferenceEntry} from "../../../../Store/main/maps/@MapState/MapSettings.js";

export const ReferencesUI = observer_mgl(({map, mapState}: {map: DMap, mapState: MapState})=>{
	const refs = (mapState.settings.general.references ?? []).filter(a=>a.enabled);
	return (
		<Row style={{
			position: "absolute", zIndex: 1, left: 0,
			//top: 25,
			top: 50, // 50, so it's not occluded even if the menu-bar gets split in two rows
			width: "100%", pointerEvents: "none", justifyContent: "center"}}>
			<Row>
				{refs.map((ref, index)=>{
					return <ReferenceUI key={index} ref={ref} index={index} mapState={mapState}/>;
				})}
			</Row>
		</Row>
	);
});

const ReferenceUI = observer_mgl(({ref, index, mapState}: {ref: SizeReferenceEntry, index: number, mapState: MapState})=>{
	const uiForErr = (msg: string)=><div style={{marginLeft: index > 0 ? 5 : 0, width: 100, height: 50, fontSize: 11, color: "rgba(255,0,0,.5)"}}>{msg}</div>;
	const forceUpdate = useForceUpdate();

	const textureEntity = GetEntity(ref.textureId);
	if (!textureEntity || !textureEntity.image_embedded) return uiForErr("(no img)");
	// example texture name, for parsing of width/height: "Bed [w:0.96m][h:1.90m]"
	const widthInMeters = textureEntity.name.match(/\[w:([0-9.]+)m\]/)?.[1]?.ToFloat();
	const heightInMeters = textureEntity.name.match(/\[h:([0-9.]+)m\]/)?.[1]?.ToFloat();
	if (widthInMeters == null && heightInMeters == null) return uiForErr("(no w/h)");

	// extra accessors (to recalculate the world->ui translation, if map zoom changes)
	mapState.camZoom_0ms; // eslint-disable-line

	const mapControls_DOM = MapSurface_Current()?.mapControls?.DOM;
	if (!mapControls_DOM) return (WaitXThenRun(100, ()=>forceUpdate()), uiForErr("(err)"));
	const oneMeterInPixels = mapControls_DOM.WorldPosToClientPos(Vec2.zero)?.x.Distance(mapControls_DOM.WorldPosToClientPos(Vec2.one).x);

	return (
		<Row style={ES(
			{
				marginLeft: index > 0 ? 5 : 0,
				opacity: mapState.settings.general.references_opacity ?? 1,
			},
			widthInMeters && {width: widthInMeters * oneMeterInPixels},
			heightInMeters && {height: heightInMeters * oneMeterInPixels},
		)}>
			<img src={textureEntity.image_embedded} style={ES(
				widthInMeters ? {width: "100%"} : {width: "auto"},
				heightInMeters ? {height: "100%"} : {height: "auto"},
			)}/>
		</Row>
	);
});